import { Box, Heading, Button, Stack, StackDivider, HStack, Spacer, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../auth/AuthProvider';
import {useApiProvider} from '../../../../api/ApiProvider';
import { RegistrationForm } from './RegistrationForm';
import ErrorMessage from '../../../parts/ErrorMessage';

const RegisterSummary: React.FC = () => {
    const userAuth = useAuth();
    const provider = useApiProvider();
    const navigate = useNavigate();

    const [submitting, setSubmitting] = useState<boolean>(false);
    const [signUpError, setSignUpError] = useState<string>("");
    const [showDialogFatherQuestion, setShowDialogFatherQuestion] = useState(false);

    const loc = useLocation();
    // const { registrationForm } = loc.state.registrationForm;


    const onSubmit = () => {
        const registrationForm: RegistrationForm = loc.state.registrationForm;
        setSubmitting(true);
        setSignUpError("");

        provider.signUp({
            name: registrationForm.name,
            surname: registrationForm.surname,
            familySurname: registrationForm.familySurname,
            phoneNumber: registrationForm.phoneNumber,
            pesel: registrationForm.pesel,
            motherName: registrationForm.motherName,
            motherSurname: registrationForm.motherSurname,
            fatherName: registrationForm.fatherName,
            street: registrationForm.street,
            buildingNumber: registrationForm.buildingNumber,
            flatNumber: registrationForm.flatNumber,
            postCode: registrationForm.postCode,
            city: registrationForm.city,
            rodoAccept: registrationForm.rodoAccept,
        })
            .then(instructor => userAuth.authUser(instructor))
            .then(() => provider.refreshAccount())
            .then(() => navigate("/"))
            .catch(err => setSignUpError(err))
            .finally(() => setSubmitting(false));
    };

    const onBack = () => {
        console.log(loc.state.registrationForm)
        navigate('/register', { state: { registrationForm: loc.state.registrationForm } })
    }

    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/forest.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                padding="5"
                margin="8"
                borderRadius="md"
                boxShadow="lg"
                textAlign="left"
                width="500px"

                marginTop="120px"
                marginBottom="20px"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                    textAlign="center"
                >
                    Podsumowanie rejestracji
                </Heading>

                {loc.state.registrationForm ? (
                    <Stack divider={<StackDivider />} spacing='4'>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Imię</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.name}</Text>
                                <Spacer />
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Nazwisko</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.surname}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Nazwisko</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.familySurname}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Numer PESEL</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.pesel}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Telefon</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.phoneNumber}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Imię matki</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.motherName}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Nazwisko rodowe matki</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.motherSurname}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Imię ojca</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.fatherName}</Text>
                            </HStack>
                        </Box>

                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Ulica</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.street} {loc.state.registrationForm.buildingNumber} {(loc.state.registrationForm.flatNumber.length>0?"m. "+loc.state.registrationForm.flatNumber:"")}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Kod Pocztowy</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.postCode}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Miejscowość</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{loc.state.registrationForm.city}</Text>
                            </HStack>
                        </Box>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Data akceptacji zgody rodo</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{new Date(loc.state.registrationForm.rodoAccept).toLocaleString()}</Text>
                            </HStack>
                        </Box>
                        <Spacer />
                    </Stack>
                ) : (
                    <Text pt='2' fontSize='sm' textTransform='uppercase'>
                        brak danych
                    </Text>
                )}

                <ErrorMessage text={signUpError} />
                <Button width="full" colorScheme="brand" onClick={onSubmit} isLoading={submitting}>Zarejestruj</Button>
                <Button width="full" onClick={onBack}>Powrót</Button>
            </Box>
        </Box>
    );
};


export default RegisterSummary;
